import { TextField } from '@mui/material';

interface IProps {
  setRegisterNumber: (RegisterNumber: string | null) => void;
  RegisterNumber: string | null | undefined;
}

const SearchRegisterNumber = (props: IProps) => {
  return (
    <TextField
      size="small"
      fullWidth
      label="Número de registro (CRM)"
      placeholder="Informe número de registro"
      value={props.RegisterNumber}
      onChange={e => {
        props.setRegisterNumber(e.target.value);
      }}
    />
  );
};

export default SearchRegisterNumber;
